import Grid from '@mui/material/Box';
import { styled } from '@mui/system';

import { ContentWrapper } from './ContentWrapper';
import { Headline } from '../Typography';

import type { FunctionComponent, PropsWithChildren } from 'react';

const StyledContainer = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    height: '52px',
    justifyContent: 'space-between',
    paddingInline: theme.spacing(3),
    width: '100%',
}));

const StyledSidebar = styled(Grid)(({ theme }) => ({
    '& > *': {
        whiteSpace: 'nowrap',
    },
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(1),
}));

type HeadlineContainerWithSidebarProps = {
    readonly headline: string;
};

export const HeadlineContainerWithSidebar: FunctionComponent<PropsWithChildren<HeadlineContainerWithSidebarProps>> = ({
    children,
    headline,
}) => (
    <ContentWrapper>
        <StyledContainer>
            <Headline variant="h5">{headline}</Headline>
            <StyledSidebar>{children}</StyledSidebar>
        </StyledContainer>
    </ContentWrapper>
);
